/*
__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\\\\\_____/\\\\\\\\\____        
 _\///////\\\/////__\///////\\\/////____/\\\\\\\\\\\\\__       
  _______\/\\\_____________\/\\\________/\\\/////////\\\_      
   _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_     
    _______\/\\\_____________\/\\\_______\/\\\\\\\\\\\\\\\_    
     _______\/\\\_____________\/\\\_______\/\\\/////////\\\_   
      _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_  
       _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_ 
        _______\///______________\///________\///________\///__
            
            COPYRIGHT TACTICAL TRANSPORTATION ADVISORS, INC. 
            ALL RIGHTS RESERVED.
*/

import React from "react";
import Dashboard from "./views/Dashboard/Dashboard";
const pages = {
  dashboard: {
    path: "/",
    element: <Dashboard />,
    loader: async () => {
      document.title = "TTA - Dashboard";
    },
  },
};

export function getPages(permissions) {
  const arr = [];
  Object.values(pages).forEach((obj) => {
    if (!obj.requiredPermission || permissions[obj.requiredPermission] === "1") {
      arr.push(obj);
    }
  });
  return arr;
}
